import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-24 flex items-center justify-between">
        <Logo size="lg" />
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
          <a href="/#features" className="hover:text-slate-900 transition-colors" data-testid="nav-features">Features</a>
          <Link to="/integrations" className="hover:text-slate-900 transition-colors" data-testid="nav-integrations">Integrations</Link>
          <a href="/#pricing" className="hover:text-slate-900 transition-colors" data-testid="nav-pricing">Pricing</a>
          <a
            href="https://SelleCheck.transactiongateway.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-3.5 h-9 rounded-full border border-[#00D533]/40 bg-[#00D533]/5 text-[#0F172A] hover:bg-[#00D533]/15 transition-colors text-xs font-semibold uppercase tracking-wider"
            data-testid="nav-gateway"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#00D533]" />
            Gateway
          </a>
          <a
            href="https://SelleSend.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-3.5 h-9 rounded-full border border-[#3B82F6]/40 bg-[#3B82F6]/5 text-[#0F172A] hover:bg-[#3B82F6]/15 transition-colors text-xs font-semibold uppercase tracking-wider"
            data-testid="nav-sellesend"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#3B82F6]" />
            SelleSend
          </a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Button
                variant="ghost"
                className="text-slate-900 hover:bg-slate-100"
                onClick={() => navigate("/dashboard")}
                data-testid="header-dashboard-btn"
              >
                Dashboard
              </Button>
              <Button
                className="bg-[#00D533] hover:bg-[#00E636] text-black font-semibold"
                onClick={async () => { await logout(); navigate("/"); }}
                data-testid="header-logout-btn"
              >
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                className="text-slate-900 hover:bg-slate-100"
                onClick={() => navigate("/login")}
                data-testid="header-login-btn"
              >
                Sign in
              </Button>
              <Button
                className="bg-[#00D533] hover:bg-[#00E636] text-black font-semibold"
                onClick={() => navigate("/register")}
                data-testid="header-register-btn"
              >
                Apply Now
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
